module.exports = __webpack_public_path__ + "static/media/revisiones.954feaa6.png";